import { AuthInitializationService } from '../services/auth-initialization.app/auth-initialization.service';

export function initializeAuth(authInitService: AuthInitializationService) {
  return () => authInitService.initializeAuth();
}
